// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F28r","comment":"styles_comment__3caxx"};